import { getQualityUrl } from '@artic/ui/lib/environment';
import { useEffect, type ReactNode } from 'react';

const qualityDevicesUrl = `${getQualityUrl()}/admin/devices`;

/**
 * Devices admin now lives in the Quality app. The Tusks device setup deep-link
 * (`/devices?setup=true&device_id=<id>`) is baked into device onboarding and
 * can't be changed on already-deployed hardware, so forward that specific link
 * to the Quality devices page with its query string intact.
 *
 * Scoped to the Tusks signature (`setup=true` + `device_id`): all other
 * `/devices` traffic — the Tusks table, the Andons tab and its own
 * `setup=true` + `hardware_id` setup link — still renders the hub page below.
 */
export default function DevicesSetupRedirect({ children }: { children: ReactNode }) {
  const params = new URLSearchParams(window.location.search);
  const isTusksSetup = params.get('setup') === 'true' && params.has('device_id');

  useEffect(() => {
    if (isTusksSetup) {
      // Cross-origin (hub → quality) so a full navigation, not react-router.
      // `replace` keeps the dead hub URL out of history; search forwarded intact.
      window.location.replace(`${qualityDevicesUrl}${window.location.search}`);
    }
  }, [isTusksSetup]);

  if (isTusksSetup) {
    return null;
  }

  return <>{children}</>;
}
